
/*
    Container for the grid of TTS Messages,

    when changes are made to those records, this is where the user will choose to either
    submit them or to reset
*/

import React from "react";

import MainContext from "../MainContext";

import SubNav from "../Components/SubNav";
import VerticalLayout from "../Components/VerticalLayout";

import MessagesTTSForm from "../Forms/MessagesTTSForm";

import { getTTSMessages, updateTTSMessages } from "../Requests/MessageRequests";

export default class MessagesTTSPage extends React.Component {

    static contextType = MainContext;

    state = {
        messages: []
    }

    componentDidMount(){
        this.loadData();
    }

    submit = () => {
        const params = {};

        const request = () => updateTTSMessages(params);
        const then = ({data}) => {
            // ...
            if(data){
                this.context.sendNotification(false, `TTS Messages Updated`);
            }
            else{
                this.context.sendNotification(false, `Update TTS messages failed, please try again`);
            }
        };

        this.context.runProcessing(request, then, "updateTTSMessages");
    }

    reset = () => {
        this.loadData();
    }

    loadData = () => {

        const request = () => getTTSMessages();

        const then = ({data}) => {
            this.setState({messages: data});
        };

        this.context.runProcessing(request, then, getTTSMessages);
    }

    updateCheck = (index, val) => {
        const copy = this.state.messages.map((mess, i) => {
            if(i === index){
                return {...mess, [val]: !mess[val]};
            }
            else{
                return mess;
            }
        });

        this.setState({messages: copy});
    }

    render() {
        return (
            <VerticalLayout firstHeight={8}>
                <SubNav>
                    <div style={{
                        display: "flex",
                        minWidth: "40vw",
                        justifyContent: "space-around",
                        alignItems: "center"
                    }}>
                        <div className="option  " style={{minWidth: "15vw"}} onClick={this.reset}>Reset</div>
                        <div className="option  " style={{minWidth: "15vw"}} onClick={this.submit}>Submit Changes</div>
                    </div>

                </SubNav>
                <div className="content">
                {
                    this.state.messages.map((mess, index) => {
                        return <MessagesTTSForm key={index} index={index} {...mess} updateCheck={this.updateCheck} />
                    })
                }
                </div>
            </VerticalLayout>
        );
    }
}
